import { makeStyles, useTheme } from "@material-ui/core";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";
import Fab from "@mui/material/Fab";
import Modal from "@mui/material/Modal";
import React from "react";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    position: "relative",
    "&:hover $overlayDiv": {
      backgroundColor: "rgba(0,0,0,0.6)",
      transition: "all 0.25s ease-in-out",
      cursor: "pointer",
    },
    "&:hover $overlayContent": {
      visibility: "visible",
    },
    "&:hover $overlayContentPadded": {
      visibility: "visible",
    },
    overflow: "hidden",
  },
  image: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    zIndex: 0,
    cursor: "pointer",
    overflow: "hidden",
  },
  overlayDiv: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0)",
    zIndex: 0,
    transition: "all 0.25s ease-in-out",
    pointerEvents: "none",
  },
  overlayContent: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    visibility: "hidden",
    fontSize: "2rem",
    color: "#FFFFFF",
    padding: "5%",
  },
  overlayContentPadded: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    visibility: "hidden",
    width: "100%",
    height: "100%",
    border: "2px solid #FFFFFF",
  },
  imgContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      display: "flex",
    },
  },
  imgContainer2: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      display: "none",
    },
  },
  abc: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    zIndex: 1300,
  },
  abcinner: {
    width: "100%",
    height: "100vh",
    position: "absolute",
    top: 0,
    right: 0,
    // background: "rgb(30, 30, 30, 0.7)",
  },
  abcinnerinner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "contain",
    width: "100%",
    height: "100vh",
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "#FFFFFF",
  },
  abcImg: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    objectFit: "cover",
    width: "100%",
    height: "100%",
    // [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
    //   width: "85%",
    //   // height: "80%",
    // },
    // [theme.breakpoints.up("xs")]: {
    //   width: "85%",
    // },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      objectFit: "contain",
      height: "auto",
    },
    // [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
    //   width: "calc(100% - 10rem)",
    // },
    // [theme.breakpoints.up("md")]: {
    //   width: "calc(100% - 10rem)",
    // },
    // [theme.breakpoints.up("lg")]: {
    //   width: "calc(100% - 10rem)",
    // },
  },
  rightButton: {
    background: "#A8626C",
    color: "#ffffff",
    position: "absolute",
    top: "50%",
    right: "1rem",
    transform: "translateY(-50%) scale(1)",
    width: "40px", // Reduced size
    height: "40px", // Reduced size
    minWidth: "40px", // Ensure consistent size
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up("xs")]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up("sm")]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      transform: "translateY(-50%) scale(1.2)",
    },
  },
  leftButton: {
    background: "#A8626C",
    color: "#ffffff",
    position: "absolute",
    top: "50%",
    left: "1rem",
    transform: "translateY(-50%) scale(1)",
    width: "40px", // Reduced size
    height: "40px", // Reduced size
    minWidth: "40px", // Ensure consistent size
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up("xs")]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up("sm")]: {
      transform: "translateY(-50%) scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      transform: "translateY(-50%) scale(1.2)",
    },
  },
  closeButton: {
    background: "#A8626C",
    color: "#ffffff",
    position: "absolute",
    top: "1rem",
    transform: "scale(1)",
    left: "calc(100% - 4rem)",
    zIndex: 1,
    width: "40px", // Reduced size
    height: "40px", // Reduced size
    boxShadow: "none",
    [theme.breakpoints.up(theme.breakpoints.values.xs - 1)]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up("xs")]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up("sm")]: {
      transform: "scale(0.8)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 167)]: {
      transform: "scale(1.2)",
    },
  },
}));

const itemData = [
  {
    img: "/images/halcyon-logo/gallery/type1_view.webp",
    alt: "Type 1",
  },
  {
    img: "/images/halcyon-logo/gallery/type2_view1.webp",
    alt: "Type 2",
  },
  {
    img: "/images/halcyon-logo/gallery/type3_view.webp",
    alt: "Type 3",
  },
  {
    img: "/images/halcyon-logo/gallery/type4_view.webp",
    alt: "Type 4",
  },
];
const AmenitiesGall = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [selectedImg, setSelectedImg] = React.useState(itemData[0]);
  const [touchStart, setTouchStart] = React.useState(null);
  const [touchEnd, setTouchEnd] = React.useState(null);

  // Minimum swipe distance threshold (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      onChangeImage("right");
    }
    if (isRightSwipe) {
      onChangeImage("left");
    }
  };
  const handleOpen = (event, key) => {
    event.preventDefault(); // Prevent default scrolling behavior
    setSelectedImg(itemData[key]);
    setOpen(true);
  };
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }
  }, [open]);
  const handleClose = () => setOpen(false);
  const classes = useStyles();
  const onChangeImage = (direction) => {
    if (direction === "right") {
      if (itemData.indexOf(selectedImg) === itemData.length - 1) {
        setSelectedImg(itemData[0]);
      } else {
        setSelectedImg(itemData[itemData.indexOf(selectedImg) + 1]);
      }
    }
    if (direction === "left") {
      if (itemData.indexOf(selectedImg) === 0) {
        setSelectedImg(itemData[itemData.length - 1]);
      } else {
        setSelectedImg(itemData[itemData.indexOf(selectedImg) - 1]);
      }
    }
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className={classes.abc}
        disableScrollLock
      >
        <div className={classes.abcinner}>
          <Fab
            className={classes.closeButton}
            onClick={() => {
              handleClose();
            }}
          >
            <Close style={{ color: "#ffffff" }} />
          </Fab>
          <div
            className={classes.abcinnerinner}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
          >
            <Fab
              className={classes.leftButton}
              onClick={() => {
                onChangeImage("left");
              }}
            >
              <ChevronLeft style={{ color: "#ffffff" }} />
            </Fab>
            <img
              src={selectedImg.img}
              alt={selectedImg.alt}
              height={512}
              width={512}
              className={classes.abcImg}
              style={{
                width: "100%",
                backgroundColor: "#FFFFFF",
                [theme.breakpoints.down("sm")]: {
                  width: "100%",
                  objectFit: "contain",
                },
              }}
            />
            <Fab
              className={classes.rightButton}
              onClick={() => {
                onChangeImage("right");
              }}
            >
              <ChevronRight style={{ color: "#ffffff" }} />
            </Fab>
          </div>
        </div>
      </Modal>
      <div className={classes.imgContainer}>
        <ImageList
          cols={3}
          rowHeight={250}
          gap={10}
        >
          {itemData.map((item, key) => (
            <div
              className={classes.parentDiv}
              key={key}
            >
              <ImageListItem />
              <img
                alt={`${item.alt}`}
                src={`${item.img}`}
                loading="lazy"
                className={classes.image}
                onClick={(event) => {
                  handleOpen(event, key);
                }}
              />
              <div className={classes.overlayDiv}>
                <div className={classes.overlayContent}>
                  <div className={classes.overlayContentPadded}>{item.alt}</div>
                </div>
              </div>
            </div>
          ))}
        </ImageList>
      </div>
      <div className={classes.imgContainer2}>
        <ImageList
          cols={1}
          rowHeight={180}
          gap={10}
        >
          {itemData.map((item, key) => (
            <div
              className={classes.parentDiv}
              key={key}
            >
              <ImageListItem />
              <img
                alt={`${item.alt}`}
                src={`${item.img}`}
                loading="lazy"
                className={classes.image}
                onClick={(event) => {
                  handleOpen(event, key);
                }}
              />
            </div>
          ))}
        </ImageList>
      </div>
    </>
  );
};

export default AmenitiesGall;
